import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import QuickBanner from './components/QuickBanner';
import StatsSection from './components/StatsSection';
import ActivitySlide from './components/ActivitySlide';
import CoursesSection from './components/CoursesSection';
import CertSection from './components/CertSection';
import GallerySection from './components/GallerySection';
import TestimonialSection from './components/TestimonialSection';
import CtaSection from './components/CtaSection';
import HomePopups from './components/HomePopups';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <HomePopups />
      <Navbar />
      <main>
        <HeroSection />
        <QuickBanner />
        <StatsSection />
        <ActivitySlide />
        <CoursesSection />
        <CertSection />
        <GallerySection />
        <TestimonialSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
